import { I18n } from "../services/I18n";
import "./generated/site-translations-de";
import common_de from "../../../../../libs/ps/restaumatic-common/locales/de.json";
import core_types_sites_de from "../../../../../libs/ps/restaumatic-core-types-sites/locales/de.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  de: { _core_types_sites: core_types_sites_de },
});
I18n.translations = I18n.extend(I18n.translations, {
  de: { _common: common_de },
});
